import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ColorPickerModule } from 'ngx-color-picker';
import { AlertComponent } from './components/alert/alert.component';
import { ApiErrorAlertComponent } from './components/api-error-alert/api-error-alert.component';
import { AppConfigurationSubmenuComponent } from './components/app-configuration-submenu/app-configuration-submenu.component';
import { AppNameInputComponent } from './components/app-name-input/app-name-input.component';
import { AppUpdateAvailableComponent } from './components/app-update-available/app-update-available.component';
import { AppUpdateModalComponent } from './components/app-update-available/app-update-modal/app-update-modal.component';
import { AutocompleteInputComponent } from './components/auto-complete-input/autocomplete-input.component';
import { ButtonComponent } from './components/button/button.component';
import { ColorSelectorComponent } from './components/color-selector/color-selector.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { HelpIconComponent } from './components/help-icon/help-icon.component';
import { IconSearchComponent } from './components/icon-search/icon-search.component';
import { ImageSizeGuideComponent } from './components/image-size-guide/image-size-guide.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { InfoboxComponent } from './components/infobox/infobox.component';
import { MainContainerComponent } from './components/main-container/main-container.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { OnboardingModalComponent } from './components/onboarding-modal/onboarding-modal.component';
import { PageConfigurationContainerComponent } from './components/page-configuration-container/page-configuration-container.component';
import { PageDesignEditorComponent } from './components/page-design-editor/page-design-editor.component';
import { PageIconAndNameEditorComponent } from './components/page-icon-and-name-editor/page-icon-and-name-editor.component';
import { PageNameErrorComponent } from './components/page-name-error/page-name-error.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { SettingContainerComponent } from './components/setting-container/setting-container.component';
import { SettingDividerComponent } from './components/setting-divider/setting-divider.component';
import { StepIndicatorComponent } from './components/step-indicator/step-indicator.component';
import { SwitchComponent } from './components/switch/switch.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './components/tooltip/tooltip.directive';
import { UnsavedChangesDialogComponent } from './components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { UpdateAvailableComponent } from './components/update-available/update-available.component';
import { DropdownIconComponent } from './components/dropdown/dropdown-icon/dropdown-icon.component';
import { AdminWarningComponent } from './components/admin-warning/admin-warning.component';

@NgModule({
  declarations: [
    FormFieldComponent,
    UpdateAvailableComponent,
    AutocompleteInputComponent,
    ConfirmationDialogComponent,
    ImageUploadComponent,
    SettingContainerComponent,
    SettingDividerComponent,
    ColorSelectorComponent,
    IconSearchComponent,
    AppConfigurationSubmenuComponent,
    ImageSizeGuideComponent,
    PageIconAndNameEditorComponent,
    PageNameErrorComponent,
    ApiErrorAlertComponent,
    PageDesignEditorComponent,
    PageConfigurationContainerComponent,
    UnsavedChangesDialogComponent,
    AppNameInputComponent,
    ButtonComponent,
    DropdownComponent,
    SwitchComponent,
    AlertComponent,
    TooltipComponent,
    TooltipDirective,
    InfoboxComponent,
    HelpIconComponent,
    OnboardingModalComponent,
    StepIndicatorComponent,
    MainContainerComponent,
    MainMenuComponent,
    AppUpdateAvailableComponent,
    RadioButtonComponent,
    AppUpdateModalComponent,
    DropdownIconComponent,
    AdminWarningComponent,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    FontAwesomeModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatInputModule,
    ColorPickerModule,
    ScrollingModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgCircleProgressModule.forRoot({}),
    MatProgressSpinnerModule,
    RouterModule,
  ],
  exports: [
    AutocompleteInputComponent,
    FormFieldComponent,
    UpdateAvailableComponent,
    ConfirmationDialogComponent,
    ImageUploadComponent,
    SettingContainerComponent,
    SettingDividerComponent,
    ColorSelectorComponent,
    IconSearchComponent,
    AppConfigurationSubmenuComponent,
    ImageSizeGuideComponent,
    PageIconAndNameEditorComponent,
    PageNameErrorComponent,
    ApiErrorAlertComponent,
    PageDesignEditorComponent,
    PageConfigurationContainerComponent,
    AppNameInputComponent,
    ButtonComponent,
    DropdownComponent,
    SwitchComponent,
    AlertComponent,
    TooltipComponent,
    RadioButtonComponent,
    TooltipDirective,
    InfoboxComponent,
    HelpIconComponent,
    OnboardingModalComponent,
    StepIndicatorComponent,
    MainContainerComponent,
    AppUpdateModalComponent,
    AdminWarningComponent,
  ],
})
export class UiModule {}
